/**
 * Money for display, Bolivian style: "Bs. 1.234,50" (dot for thousands, comma for decimals).
 * Built by hand instead of Intl so every browser prints the same thing (Spanish locales
 * skip the thousands dot on 4-digit numbers). Display only: inputs, CSV exports and
 * database values keep plain numbers.
 */

export interface MoneyParts {
  negative: boolean;
  /** Integer part with thousand separators, e.g. "1.234" */
  integer: string;
  /** Two decimal digits, e.g. "50" */
  decimals: string;
}

export function splitMoney(value: number | string | null | undefined): MoneyParts {
  const n = Number(value ?? 0);
  const safe = Number.isFinite(n) ? n : 0;
  const [int, dec] = Math.abs(safe).toFixed(2).split('.');
  return {
    negative: safe < 0 && Math.abs(safe) >= 0.005,
    integer: int.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
    decimals: dec,
  };
}

/** "1.234,50" (no currency) */
export function formatAmount(value: number | string | null | undefined): string {
  const { negative, integer, decimals } = splitMoney(value);
  return `${negative ? '-' : ''}${integer},${decimals}`;
}

/** "Bs. 1.234,50" */
export function formatBs(value: number | string | null | undefined): string {
  const { negative, integer, decimals } = splitMoney(value);
  return `${negative ? '-' : ''}Bs. ${integer},${decimals}`;
}
